<template>
  <modal
    width="480px"
    speed="fast"
    noOutClose
    maskNoClick
    :show="show"
    enter-active-class="fadeIn"
    leave-active-class="fadeOut"
    @update:show="close"
    class="camera-error-tip"
  >
    <p slot="header">考中异常通知</p>
    <p slot="content" class="text">
      <!--考生你好，系统检测到你的摄像头&麦克风存在异常，请你安心继续答题。<br/>-->
      <!--为保障考试的公平公正，请考生按照如下方式处理：<br/>-->
      <!--1. 点击考试页面【问题上报】按钮进行报备，继续完成考试。<br/>-->
      <!--2. 发起家长协助，跟进手机录像。<br/>-->
      <!--3. 与工作人员取得联系，将录像按照指定方式发送给主办方。-->
      系统检测到您的摄像头及麦克风无法正常使用。<br/>
      请参赛选手继续安心答题，赛事结束后，组委会将结合相关考试行为数据以及辅助监考设备的记录进行二次人工核验。
    </p>
    <!--<div slot="footer">-->
      <!--<a href="https://shimo.im/docs/gtrrTvKvvKGxjTDy/" class="blue-btn" target="_blank">解决方案</a>-->
    <!--</div>-->
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
export default {
  components: {
    Modal
  },
  data() {
    return {
      show: true
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/.modal-head {
    padding: 16px 20px;
    border-bottom: 1px solid #F1F1F1;
  }
  .camera-error-tip {
    .text {
      font-size: 16px;
      color: #333;
      text-align: left;
      span {
        font-weight: 500;
      }
    }
  }
  .blue-btn {
    display: inline-block;
    @include theme-fill-btn(96px, 36px, 14px, 4px);
    margin-bottom: 10px;
  }
</style>
